var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserGuideHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8 6.6001H29H17H1.2C1.08954 6.6001 1 6.68964 1 6.8001V28.0001C1 28.1106 1.08954 28.2001 1.2 28.2001H32.8C32.9105 28.2001 33 28.1106 33 28.0001V6.8001C33 6.68964 32.9105 6.6001 32.8 6.6001Z",
    fill: "#EE7233",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 16.2H8.8C8.91046 16.2 9 16.2895 9 16.4V21.6C9 21.7104 8.91046 21.8 8.8 21.8H5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21.8H12.2",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7154 1.1328L17.1154 6.54614C17.045 6.579 17 6.64967 17 6.72737V27.886C17 28.0323 17.152 28.1291 17.2846 28.0672L28.8846 22.6539C28.955 22.621 29 22.5503 29 22.4726V1.31404C29 1.16772 28.848 1.07092 28.7154 1.1328Z",
    fill: "#EE7233",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3984 22.6L24.1984 20.2",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3984 10.5999L26.5984 7.3999",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3984 14.5999L26.5984 11.3999",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3984 18.5999L26.5984 15.3999",
    stroke: "white",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 31.3999H15.2764C15.3521 31.3999 15.4225 31.4423 15.4472 31.514C15.6393 32.0716 15.5073 32.9999 17 32.9999C18.3713 32.9999 18.3443 32.0709 18.5514 31.5134C18.5777 31.4424 18.6479 31.3999 18.7236 31.3999H33",
    stroke: "#EE7233",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.20156,
    cy: 12.9999,
    r: 1.1,
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGuideHover);
export default __webpack_public_path__ + "static/media/User Guide_hover.6194961208e2f74f3fc2377e8970422d.svg";
export { ForwardRef as ReactComponent };